import * as css from 'css/exports.module.scss';

import './ImportStatistics.scss';

import { ImportSummary } from '@sonar-software/sonar-imports';
import React from 'react';
import { StatisticDelta } from '@ui/general';

import { Col, Row, Statistic } from 'antd';
import { COPY_SONAR_OBJECT_BASE_PLURAL, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';

export interface ImportStatisticsProps {
	summary: ImportSummary | null | undefined;
}

export const ImportStatistics: React.FC<ImportStatisticsProps> = ({ summary }) => {
	if (!summary) {
		return null;
	}

	const {
		apexClasses,
		apiCallCount,
		entitiesDefinitions,
		fields,
		flows,
		totalSynced,
		validationRules,
		workflowRules
	} = summary;

	return (
		<div id='import-statistics'>
			<div className='statistics'>
				<Row gutter={ [ Number(css.size16), Number(css.size16) ] }>
					<Col span={ 6 }>
						<Statistic
							suffix={ <StatisticDelta change={ fields.change } /> }
							title={ COPY_SONAR_OBJECT_BASE_PLURAL.FIELD }
							value={ fields.count } />
					</Col>

					<Col span={ 6 }>
						<Statistic
							suffix={ <StatisticDelta change={ workflowRules.change } /> }
							title={ COPY_SONAR_OBJECT_BASE_PLURAL.WORKFLOW_RULE }
							value={ workflowRules.count } />
					</Col>

					<Col span={ 6 }>
						<Statistic
							suffix={ <StatisticDelta change={ validationRules.change } /> }
							title={ COPY_SONAR_OBJECT_BASE_PLURAL.VALIDATION_RULE }
							value={ validationRules.count } />
					</Col>

					<Col span={ 6 }>
						<Statistic
							suffix={ <StatisticDelta change={ flows.change } /> }
							title={ COPY_SONAR_OBJECT_BASE_PLURAL.FLOW }
							value={ flows.count } />
					</Col>

					<Col span={ 6 }>
						<Statistic
							suffix={ <StatisticDelta change={ apexClasses.change } /> }
							title={ COPY_SPECIFIC.APEX }
							value={ apexClasses.count } />
					</Col>

					<Col span={ 6 }>
						<Statistic
							suffix={ <StatisticDelta change={ entitiesDefinitions.change } /> }
							title={ COPY_SPECIFIC.TOTAL_ENTITIES }
							value={ entitiesDefinitions.count } />
					</Col>

					<Col span={ 6 }>
						<Statistic
							title={ COPY_SPECIFIC.API_CALLS }
							value={ apiCallCount } />
					</Col>

					<Col span={ 6 }>
						<Statistic
							suffix={ <StatisticDelta change={ totalSynced.change } /> }
							title={ COPY_SPECIFIC.TOTAL_DATA_SYNC }
							value={ totalSynced.count } />
					</Col>
				</Row>
			</div>
		</div>
	);
};
